import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { BillAccountsService } from '../../services/bill-accounts.service';
import {
  billAccountsLoadDocumentsFromExpAPI,
  billAccountsLoadDocumentsFromExpApiFail,
  billAccountsLoadDocumentsFromExpApiSuccess
} from './billaccountExpDocuments.actions';

export const loadBillAccountDocumentsFromExpAPI = createEffect(
  (action$ = inject(Actions), billingService = inject(BillAccountsService)) => {
    return action$.pipe(
      ofType(billAccountsLoadDocumentsFromExpAPI),
      map(action => action.payload),
      switchMap(() =>
        billingService.getBillAccountsDocumentsFromExpApi().pipe(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          map((fetchedBillAccount: any) => {
            if (fetchedBillAccount['response'] === null) {
              return billAccountsLoadDocumentsFromExpApiSuccess([]);
            }
            return billAccountsLoadDocumentsFromExpApiSuccess(fetchedBillAccount['response']);
          }),
          catchError(error => {
            return of(billAccountsLoadDocumentsFromExpApiFail(error));
          })
        )
      )
    );
  },
  { functional: true }
);
